import * as React from 'react';
import { useContext } from 'react';

import type { CoursePrice } from 'bundles/seo/components/course-rich-search-card/types';

const CoursePriceContext = React.createContext<CoursePrice | undefined>(undefined);

export const useCoursePrice = () => {
  return useContext(CoursePriceContext);
};

export default CoursePriceContext;
